/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Import Onshape reference model</h4>

<p>Import a model from an Onshape Studio, to use as reference. The model will be displayed in blue and will
not be editable by default.</p>

<p>Optionally, Phi can attempt to convert the reference into an editable Phi body (some limitations apply).</p>`;

export default function ImportPartstudioTooltip() {
    return h('div', { innerHTML: body });
}
